<!-- 多级折叠面板-->
<template>
  <div class="fold-panel">
    <div class="panel-header" @click="toggle" :class="['header-bg-' + isOnes]">
      <div class="">
        <div
          class=""
          style="font-size: 15px; font-weight: 500; color: #fff; display: flex"
        >
          {{ title }}
        </div>
        <div class="styTime" style="font-size: 13px; margin-top: 5px">
          {{ times }}
        </div>
      </div>
      <div
        class=""
        style="display: flex; align-items: center; margin-left: 8px"
      >
        <div
          class="styMoney"
          style="margin-right: 10px; font-size: 15px; word-break: break-all"
        >
          {{ money }}
        </div>
        <div class="arrow-icon" v-if="hasChildren">
          <img
            v-if="!isOpen"
            src="@/assets/image/Miracle/team/ru.png"
            style="width: 15px; object-fit: contain"
          />
          <img
            v-if="isOpen"
            src="@/assets/image/Miracle/team/bu.png"
            style="width: 15px; object-fit: contain"
          />
        </div>
      </div>
    </div>
    <div v-show="isOpen && children.length > 0" class="panel-content">
      <slot></slot>
      <div v-if="isOpen">
        <fold-panel
          v-for="(child, index) in children"
          :key="index"
          :title="child.title"
          :money="child.money"
          :times="child.times"
          :isOnes="child.isOnes"
          :children="child.children"
        ></fold-panel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FoldPanel",
  props: {
    title: {
      type: String,
      required: true,
    },
    money: {
      type: String,
      required: true,
    },
    times: {
      type: String,
      required: true,
    },
    isOnes: {
      type: String,
      required: true,
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isOpen: false,
      hasChildren: this.children.length != 0,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>